import {useContext} from 'react';
import {
  CANCEL_SCHEDULED_CHANGE_MODAL,
  CANCELING_SCHEDULED_CHANGE_LOADING_MODAL,
  FEATURE_DETAILS_MODAL,
  FORGOT_PASSWORD_SUCCESS_MODAL,
  HELP_AND_SUPPORT_MODAL,
  INACTIVE_USER_MODAL,
  INCOMPLETE_BILLING_MODAL,
  PAYMENT_FAILED_MODAL,
  PAYMENT_PROCESSING_MODAL,
  SENDING_EMAIL_LOADING_MODAL,
  BILLING_LOAD_ERROR_MODAL,
  REACTIVATE_PLAN_MODAL,
  REACTIVATING_PLAN_LOADING_MODAL,
  SUSPENDED_MODAL,
} from '../../constants/modals';
import {globalUIContext} from '../../utils/global-ui-helpers';
import FeatureDetailsModal from './FeatureDetailsModal';
import ForgotPasswordSuccessModal from './ForgotPasswordSuccessModal';
import InactiveUserModal from './InactiveUserModal';
import {LoadingModal} from './LoadingModal';
import HelpAndSupportModal from './HelpAndSupport';
import PaymentProcessing from './PaymentProcessing';
import PaymentFailed from './PaymentFailed';
import BillingLoadErrorModal from './BillingLoadErrorModal';
import ReactivatePlanModal from './ReactivatePlanModal';
import CancelScheduledChangeModal from './CancelScheduledChangeModal';
import SuspendedModal from './SuspendedModal';
import IncompleteBillingModal from './IncompleteBillingModal';

export const RedesignModal = () => {
  const {modal, closeModal} = useContext(globalUIContext);

  if (!modal?.modalName) {
    return null;
  }

  switch (modal.modalName) {
    case FORGOT_PASSWORD_SUCCESS_MODAL:
      return <ForgotPasswordSuccessModal handleClose={closeModal} />;
    case INACTIVE_USER_MODAL:
      return <InactiveUserModal handleClose={closeModal} />;
    case SUSPENDED_MODAL:
      return <SuspendedModal handleClose={closeModal} />;
    case HELP_AND_SUPPORT_MODAL:
      return <HelpAndSupportModal handleClose={closeModal} />;
    case SENDING_EMAIL_LOADING_MODAL:
      return (
        <LoadingModal
          title="Sending email"
          description="Please wait while we send you a verification email."
        />
      );
    case REACTIVATING_PLAN_LOADING_MODAL:
      return (
        <LoadingModal
          title="Reactivating plan"
          description="Please wait while we reactivate your plan."
        />
      );
    case PAYMENT_PROCESSING_MODAL:
      return <PaymentProcessing />;
    case PAYMENT_FAILED_MODAL:
      return <PaymentFailed handleClose={closeModal} />;
    case BILLING_LOAD_ERROR_MODAL:
      return <BillingLoadErrorModal handleClose={closeModal} />;
    case FEATURE_DETAILS_MODAL:
      return (
        <FeatureDetailsModal
          featureKey={
            (modal.modalProps.featureKey as string | null | undefined) ?? null
          }
          handleClose={closeModal}
        />
      );
    case REACTIVATE_PLAN_MODAL:
      return (
        <ReactivatePlanModal
          handleClose={closeModal}
          onConfirm={modal.modalProps.onConfirm as () => void}
        />
      );
    case CANCEL_SCHEDULED_CHANGE_MODAL:
      return (
        <CancelScheduledChangeModal
          handleClose={closeModal}
          onConfirm={modal.modalProps.onConfirm as () => void}
          currentPlanDisplayName={
            modal.modalProps.currentPlanDisplayName as string
          }
        />
      );
    case CANCELING_SCHEDULED_CHANGE_LOADING_MODAL:
      return (
        <LoadingModal
          title="Canceling change"
          description="Please wait while we cancel your scheduled plan change."
        />
      );
    case INCOMPLETE_BILLING_MODAL:
      return (
        <IncompleteBillingModal
          redirectUrl={
            (modal.modalProps.redirectUrl as string) ?? window.homeUrl ?? ''
          }
        />
      );

    default:
      return null;
  }
};
